import { makeStyles } from '@mui/styles'

// TODO: potential refactor?
const useStyles = makeStyles(theme => ({
  inset: {
    height: 1,
    marginLeft: 0,
    position: 'relative',
    border: 'none',
    backgroundColor: 'transparent',
    backgroundImage: `linear-gradient(90deg, ${theme.palette.neutral.lighter}, ${theme.palette.neutral.lighter} 35%, transparent 35%, transparent 100%)`,
    backgroundSize: theme.spacing(1),
    overflow: 'visible',

    '&:before, &:after': {
      content: "''",
      position: 'absolute',
      top: -3,
      height: 7,
      width: 7,
      backgroundColor: theme.palette.neutral.lighter,
      transform: 'rotate(45deg)',
      borderRadius: '50%',
    },

    '&:before': {
      left: 0,
    },
    '&:after': {
      right: 0,
    },

    '&.MuiDivider-light': {
      backgroundImage: `linear-gradient(90deg, ${theme.palette.primary.lighter}, ${theme.palette.primary.lighter} 35%, transparent 35%, transparent 100%)`,

      '&:before, &:after': {
        backgroundColor: theme.palette.primary.lighter,
      },
    },
  },

  hiddenStart: {
    '&:before': {
      display: 'none',
    },
  },

  hiddenEnd: {
    '&:after': {
      display: 'none',
    },
  },

  vertical: {
    width: 1,
    height: '100%',
    '&$inset': {
      backgroundImage: `linear-gradient(top, ${theme.palette.neutral.lighter}, ${theme.palette.neutral.lighter} 35%, transparent 35%, transparent 100%)`,
      backgroundSize: theme.spacing(1, 1),

      '&.MuiDivider-light': {
        backgroundImage: `linear-gradient(top, ${theme.palette.primary.lighter}, ${theme.palette.primary.lighter} 35%, transparent 35%, transparent 100%)`,
      },
    },

    '&:before, &:after': {
      right: 0,
      left: -3,
    },

    '&:before': {
      top: 0,
    },
    '&:after': {
      top: '100%',
    },
  },

  middle: {
    width: theme.spacing(4.5),
    height: 1,
    marginLeft: 0,

    '&.MuiDivider-light': {
      backgroundColor: theme.palette.primary.lightest,
    },
  },

  hasSmallDots: {
    '&:before, &:after': {
      top: -2,
      width: 5,
      height: 5,
    },
  },

  animated: {
    animation: '$dashX 800s linear infinite',

    '&$vertical': {
      animation: '$dashY 800s linear infinite',
    },
  },

  // KEYFRAMES
  '@keyframes dashX': {
    to: {
      backgroundPosition: '10000px 0',
    },
  },
  '@keyframes dashY': {
    to: {
      backgroundPosition: '0 10000px',
    },
  },
}))

export default useStyles
